<template>
  <v-autocomplete
      :multiple="multiple"
      :prepend-icon="icon"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      v-model="item"
      :label="$t('afip.factura.labels.Alicuota')"
      :loading="loading"
      :error="hasInputErrors('Alicuota')"
      :error-messages="getInputErrors('Alicuota')"
      color="secondary"
      item-color="secondary"
      :rules="required"
      :hide-details="hideDetails"
      :outlined="outlined"
      :persistent-hint="persistentHint"
      :dense="dense"
  ></v-autocomplete>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import AfipProvider from "@/modules/afip/providers/AfipProvider";

export default {
  name: "TipoAlicuotaCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: [String, Number, Array]
    },
    icon: {type: String},
    itemText: {type: String, default: "Desc"},
    itemValue: {type: String, default: "Id"},
    multiple: {type: Boolean, default: false},
    hideDetails: {type: Boolean, default: false},
    outlined: {type: Boolean, default: false},
    persistentHint: {type: Boolean, default: false},
    dense: {type: Boolean, default: false},
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      AfipProvider.getTipoAlicuotas().then(r => {
        this.items = r.data.getTipoAlicuotas
      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>

